import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { Lookup } from 'src/app/core/models/common/Lookup';
import {
  AgentData,
  AuthorityData,
  AuthorityOwnerData,
  ParticipantData,
  PersonData,
  RegistrationModel,
} from 'src/app/core/models/user-profile/registration.model';
import {
  AgentDto,
  AuthorityOwnerModel,
  AuthorityProfileModel,
  PersonProfileModel,
  UserProfileAgentModel,
  UserProfileLookups,
  UserProfileLookupsModel,
} from 'src/app/core/models/user-profile/user-profile.model';
import { BaseMapper } from 'src/app/shared/base/BaseMapper';

@Injectable()
export class ProfileMapper extends BaseMapper {
  mapPersonData(updatePerson: PersonProfileModel): RegistrationModel {
    let newPerson: RegistrationModel = {
      Token: updatePerson.Token,
      IsFromSSO: true,
      Email: updatePerson.Email,
      ParticipantToRegister: {
        ...this.mapParticipantDto(updatePerson),
        ParticipantType: 'Person',
      },
      PersonToRegister: this.mapPerosnDto(updatePerson),
    };
    return newPerson;
  }

  mapAuthorityData(updateAuthority: AuthorityProfileModel): RegistrationModel {
    let newAuthority: RegistrationModel = {
      Token: updateAuthority.Token,
      IsFromSSO: true,
      Email: updateAuthority.Email,
      ParticipantToRegister: {
        ...this.mapParticipantDto(updateAuthority),
        ParticipantType: 'Authority',
      },
      AuthorityToRegister: this.mapAuthorityDto(updateAuthority),
    };
    return newAuthority;
  }

  mapParticipantDto(updateuser: PersonProfileModel): ParticipantData {
    let ParticipantToRegister: ParticipantData = {
      RegistrationType: 'Forms',
      CreatedBy: 'System',
      LastModifiedBy: 'System',
      NameAr: updateuser.NameAr,
      NameEn: updateuser.NameEn,
      NameUr: updateuser.NameEn,
      EmirateId: updateuser.Emirate?.id,
      PoBox: updateuser.PoBox,
      City: updateuser.City,
      PreferedLanguage: updateuser.PreferedLanguage?.nameEn,
      ParticipantAddress: updateuser.Address,
      Mobile: updateuser.Mobile,
      Email: updateuser.Email,
      SecondaryMobile: updateuser.SecondaryMobile,
      Phone: updateuser.PhoneNumber,
      Fax: updateuser.Fax,
      CustomerServiceCenterID: updateuser.ServiceCenter?.id,
      Area: updateuser.Area,
      Street: updateuser.Street,
      appNotification: updateuser.NotificationTypes?.some(
        (n) => n.code == 'AppNotifications'
      ),
      smsNotification: updateuser.NotificationTypes?.some(
        (n) => n.code == 'SMS'
      ),
      emailNotification: updateuser.NotificationTypes?.some(
        (n) => n.code == 'Email'
      ),
    };
    return ParticipantToRegister;
  }

  mapPerosnDto(updatePerson: PersonProfileModel): PersonData {
    let PersonToRegister: PersonData = {
      CountryId: updatePerson.Nationality?.id,
      ResidencyStatus: updatePerson.ResidencyType?.id,
      PassportNumber: updatePerson.Passport,
      IdNumber: updatePerson.IdNumber,
      Sex: updatePerson.Gender.nameEn,
      IsDisableUser: updatePerson.HasDisability,
      PersonDisabilityTypeIDs: updatePerson.HasDisability
        ? updatePerson.Disabilities.map((d) => d.id)
        : [],
      BirthDate: updatePerson.BirthDate?.toLocaleString('dd-MM-yyyy'),
      JobId: updatePerson.Job?.id,
      IsMarried: updatePerson.MaritalStatus?.nameEn == 'Married',
      FamilyMembersNumber: updatePerson.FamilyMembersNumber,
      TotalIncome: updatePerson.TotalIncome,
    };
    return PersonToRegister;
  }

  mapAuthorityDto(updateAuthority: AuthorityProfileModel): AuthorityData {
    let authorityToRegister: AuthorityData = {
      Latitude: updateAuthority.Location?.latitude?.toString(),
      Longitude: updateAuthority.Location?.longitude?.toString(),
      AuthorityType: 'NormalCompany',
      LegalStatusId: updateAuthority.LegalStatus?.id,
      TradeLicenseNumber: updateAuthority.LicenseNumber,
      LicenseType: updateAuthority.LicenseType?.code,
      LicenseIssueDateFrom: updateAuthority.LicenseIssuanceDate?.toString(),
      LicenseIssueDateTo: updateAuthority.LicenseExpiryDate?.toString(),
      LicenseIssueingSource: updateAuthority.LicenseIssuer?.id,
      Owners: updateAuthority.Owners?.map((o) => {
        return {
          authorityOwnerId: o.Id,
          name: o.NameEn,
          nameAR: o.NameAr,
          nameUR: o.NameEn,
          mobile: o.Mobile,
          nationality: o.Nationality?.id,
          partnershipType: o.PartnershipType?.id,
          idNumber: o.IdNumber,
          passportNumber: o.Passport,
        } as AuthorityOwnerData;
      }),
      Agents: updateAuthority.Agents?.map((a) => {
        return this.mapAgentToDto(a);
      }),
    };
    return authorityToRegister;
  }

  constructor(protected datePipe: DatePipe) {
    super(datePipe);
  }

  mapLookups(lookupsDto: UserProfileLookupsModel): UserProfileLookups {
    var lookups = new UserProfileLookups();
    lookups.Countries = this.mapLookup(lookupsDto.Countries);
    lookups.Genders = this.mapLookup(lookupsDto.Genders);
    lookups.Emirates = this.mapLookup(lookupsDto.Emirates);
    lookups.ResidencyTypes = this.mapLookup(lookupsDto.ResidencyTypes);
    lookups.Disabilities = this.mapLookup(lookupsDto.DisabilityType);
    lookups.LicenseTypes = this.mapLookup(lookupsDto.LicenseTypes);
    lookups.LegalStatuses = this.mapLookup(lookupsDto.LegalStatuses);
    lookups.LicenseIssuers = this.mapLookup(lookupsDto.LicenseIssuers);
    lookups.Languages = this.mapPreferedLanguageLookups();
    lookups.PartnershipTypes = this.mapLookup(lookupsDto.PartnershipTypes);
    lookups.GeoAreas = this.mapLookup(lookupsDto.GeoAreas);
    lookups.ServiceCenters = this.mapLookup(lookupsDto.ServiceCenters);
    lookups.Jobs = this.mapLookup(lookupsDto.Jobs);
    lookups.MaritalStatuses = this.mapLookup(lookupsDto.MaritalStatuses);
    lookups.NotificationTypes = this.mapLookup(lookupsDto.NotificationMethods);
    return lookups;
  }

  mapAuthorityLookups(lookupsDto: UserProfileLookupsModel): UserProfileLookups {
    var lookups = new UserProfileLookups();
    lookups.Countries = this.mapLookup(lookupsDto.Countries);
    lookups.Emirates = this.mapLookup(lookupsDto.Emirates);
    lookups.LicenseTypes = this.mapLookup(lookupsDto.LicenseTypes);
    lookups.LegalStatuses = this.mapLookup(lookupsDto.LegalStatuses);
    lookups.PartnershipTypes = this.mapLookup(lookupsDto.PartnershipTypes);
    return lookups;
  }

  mapPersonLookups(lookupsDto: UserProfileLookupsModel): UserProfileLookups {
    var lookups = new UserProfileLookups();
    lookups.Countries = this.mapLookup(lookupsDto.Countries);
    lookups.Genders = this.mapLookup(lookupsDto.Genders);
    lookups.Emirates = this.mapLookup(lookupsDto.Emirates);
    lookups.ResidencyTypes = this.mapLookup(lookupsDto.ResidencyTypes);
    return lookups;
  }

  mapLookup(lookupArray: any[]): Lookup[] {
    if (lookupArray == null) return [];
    return lookupArray.map((i) => {
      return this.mapLookupItem(i);
    });
  }

  mapLookupItem(lookupDto: any): Lookup {
    if (lookupDto)
      return {
        id: lookupDto.Id,
        code: lookupDto.Code,
        nameAr: lookupDto.NameAr,
        nameEn: lookupDto.NameEn,
      };
    else return null;
  }

  mapPersonProfile(
    model: RegistrationModel,
    lookups: UserProfileLookups
  ): PersonProfileModel {
    let profileModel: PersonProfileModel = {};

    profileModel.Username = model.UserName;
    profileModel.ParticipantNumber =
      model.ParticipantToRegister?.ParticipantNumber;
    profileModel.Email = model.ParticipantToRegister?.Email;

    profileModel.NameAr = model.ParticipantToRegister?.NameAr;
    profileModel.NameEn = model.ParticipantToRegister?.NameEn;
    profileModel.NameUr = model.ParticipantToRegister?.NameUr;
    profileModel.Gender = lookups?.Genders?.find(
      (g) => g.nameEn == model.PersonToRegister?.Sex
    );
    profileModel.HasDisability = model.PersonToRegister?.IsDisableUser;
    profileModel.Disabilities = lookups?.Disabilities?.filter((d) =>
      model.PersonToRegister?.PersonDisabilityTypeIDs?.includes(d.id)
    );
    profileModel.Nationality = lookups?.Countries?.find(
      (c) => c.id == model?.PersonToRegister?.CountryId
    );
    profileModel.ResidencyType = lookups?.ResidencyTypes?.find(
      (c) => c.id == model.PersonToRegister?.ResidencyStatus
    );
    profileModel.IdNumber = model.PersonToRegister?.IdNumber;
    profileModel.Passport = model.PersonToRegister?.PassportNumber;

    if (model.PersonToRegister?.BirthDate) {
      var dateParts = model.PersonToRegister?.BirthDate.split('-');
      profileModel.BirthDate = new Date(
        +dateParts[2],
        +dateParts[1] - 1,
        +dateParts[0]
      );
    }

    profileModel.Job = lookups?.Jobs?.find(
      (c) => c.id == model.PersonToRegister?.JobId
    );
    profileModel.MaritalStatus = this.mapMaritalStatus(
      model.PersonToRegister?.IsMarried,
      lookups
    );

    profileModel.FamilyMembersNumber =
      model.PersonToRegister?.FamilyMembersNumber;
    profileModel.TotalIncome = model.PersonToRegister?.TotalIncome;

    profileModel.Mobile = model.ParticipantToRegister?.Mobile;
    profileModel.SecondaryMobile = model.ParticipantToRegister?.SecondaryMobile;
    profileModel.PhoneNumber = model.ParticipantToRegister?.Phone;
    profileModel.Fax = model.ParticipantToRegister?.Fax;
    profileModel.PoBox = model.ParticipantToRegister?.PoBox;
    profileModel.Area = model.ParticipantToRegister?.Area;
    profileModel.Emirate = lookups?.Emirates?.find(
      (c) => c.id == model.ParticipantToRegister?.EmirateId
    );
    profileModel.ServiceCenter = lookups.ServiceCenters?.find(
      (c) => c.id == model.ParticipantToRegister?.CustomerServiceCenterID
    );
    profileModel.City = model.ParticipantToRegister?.City;
    profileModel.Address = model.ParticipantToRegister?.ParticipantAddress;
    profileModel.Street = model.ParticipantToRegister?.Street;
    profileModel.PreferedLanguage = lookups?.Languages?.find(
      (c) => c.nameEn == model.ParticipantToRegister?.PreferedLanguage
    );
    profileModel.NotificationTypes = [];
    if (model.ParticipantToRegister?.appNotification) {
      profileModel.NotificationTypes.push(
        lookups?.NotificationTypes?.find((c) => c.code == 'AppNotifications')
      );
    }
    if (model.ParticipantToRegister?.smsNotification) {
      profileModel.NotificationTypes.push(
        lookups?.NotificationTypes?.find((c) => c.code == 'SMS')
      );
    }
    if (model.ParticipantToRegister?.emailNotification) {
      profileModel.NotificationTypes.push(
        lookups?.NotificationTypes?.find((c) => c.code == 'Email')
      );
    }
    profileModel.Agents = [];
    model.PersonToRegister?.Agents?.forEach((a) => {
      profileModel.Agents.push(this.mapAgent(a, lookups));
    });
    return profileModel;
  }

  mapAuthorityProfile(
    model: RegistrationModel,
    lookups: UserProfileLookups
  ): AuthorityProfileModel {
    let profileModel: AuthorityProfileModel = {};

    profileModel.Username = model.UserName;
    profileModel.ParticipantNumber =
      model.ParticipantToRegister?.ParticipantNumber;
    profileModel.Email = model.ParticipantToRegister?.Email;

    profileModel.NameAr = model.ParticipantToRegister?.NameAr;
    profileModel.NameEn = model.ParticipantToRegister?.NameEn;
    profileModel.NameUr = model.ParticipantToRegister?.NameUr;

    profileModel.LegalStatus = lookups?.LegalStatuses?.find(
      (c) => c.id == model.AuthorityToRegister?.LegalStatusId
    );
    profileModel.LicenseNumber = model.AuthorityToRegister?.TradeLicenseNumber;
    profileModel.LicenseType = lookups?.LicenseTypes?.find(
      (c) => c.code == model.AuthorityToRegister?.LicenseType
    );
    profileModel.LicenseIssuer = lookups?.LicenseIssuers?.find(
      (c) => c.id == model.AuthorityToRegister?.LicenseIssueingSource
    );
    profileModel.LicenseIssuanceDate = new Date(
      model.AuthorityToRegister?.LicenseIssueDateFrom
    );
    profileModel.LicenseExpiryDate = new Date(
      model.AuthorityToRegister?.LicenseIssueDateTo
    );
    profileModel.Longtuide = model.AuthorityToRegister?.Longitude;
    profileModel.Latitude = model.AuthorityToRegister?.Latitude;
    profileModel.Location = {
      latitude: parseFloat(model.AuthorityToRegister?.Latitude),
      longitude: parseFloat(model.AuthorityToRegister?.Longitude),
      address: null,
    };
    profileModel.Owners = [];
    model.AuthorityToRegister?.Owners?.forEach((a) => {
      profileModel.Owners.push(this.mapOwner(a, lookups));
    });

    profileModel.Mobile = model.ParticipantToRegister?.Mobile;
    profileModel.SecondaryMobile = model.ParticipantToRegister?.SecondaryMobile;
    profileModel.PhoneNumber = model.ParticipantToRegister?.Phone;
    profileModel.Fax = model.ParticipantToRegister?.Fax;
    profileModel.PoBox = model.ParticipantToRegister?.PoBox;
    profileModel.Area = model.ParticipantToRegister?.Area;
    profileModel.Emirate = lookups?.Emirates?.find(
      (c) => c.id == model.ParticipantToRegister?.EmirateId
    );
    profileModel.ServiceCenter = lookups.ServiceCenters?.find(
      (c) => c.id == model.ParticipantToRegister?.CustomerServiceCenterID
    );
    profileModel.City = model.ParticipantToRegister?.City;
    profileModel.Address = model.ParticipantToRegister?.ParticipantAddress;
    profileModel.Street = model.ParticipantToRegister?.Street;
    profileModel.PreferedLanguage = lookups?.Languages?.find(
      (c) => c.nameEn == model.ParticipantToRegister?.PreferedLanguage
    );
    profileModel.NotificationTypes = [];
    if (model.ParticipantToRegister?.appNotification) {
      profileModel.NotificationTypes.push(
        lookups?.NotificationTypes?.find((c) => c.code == 'AppNotifications')
      );
    }
    if (model.ParticipantToRegister?.smsNotification) {
      profileModel.NotificationTypes.push(
        lookups?.NotificationTypes?.find((c) => c.code == 'SMS')
      );
    }
    if (model.ParticipantToRegister?.emailNotification) {
      profileModel.NotificationTypes.push(
        lookups?.NotificationTypes?.find((c) => c.code == 'Email')
      );
    }
    profileModel.Agents = [];
    model.AuthorityToRegister?.Agents?.forEach((a) => {
      profileModel.Agents.push(this.mapAgent(a, lookups));
    });
    return profileModel;
  }

  mapPreferedLanguageLookups(): Lookup[] {
    return [
      {
        id: 0,
        code: 'en',
        nameAr: 'الإنجليزية',
        nameEn: 'English',
      },
      {
        id: 1,
        code: 'ar',
        nameAr: 'العربية',
        nameEn: 'Arabic',
      },
      {
        id: 2,
        code: 'ur',
        nameAr: 'أردو',
        nameEn: 'Urdu',
      },
    ];
  }

  mapMaritalStatus(
    IsMarried: boolean,
    UserProfileLookups: UserProfileLookups
  ): Lookup {
    if (IsMarried) {
      return UserProfileLookups?.MaritalStatuses?.find(
        (c) => c.nameEn == 'Married'
      );
    } else {
      return UserProfileLookups?.MaritalStatuses?.find(
        (c) => c.nameEn == 'Single'
      );
    }
  }

  mapAgent(
    agent: AgentData,
    lookups: UserProfileLookups
  ): UserProfileAgentModel {
    return {
      Id: agent.IndividualAgentID
        ? agent.IndividualAgentID
        : agent.AuthorityAgentID,
      IdentityType: agent.IdNumber ? 'IdNumber' : 'Passport',
      IdNumber: agent.IdNumber,
      Passport: agent.PassportNumber,
      NameAr: agent.Name,
      NameEn: agent.Name,
      Email: agent.Email,
      Mobile: agent.Mobile,
      PreferedLanguage: lookups?.Languages?.find(
        (c) => c.nameEn == agent.PreferedLanguage
      ),
      LoginPermission: agent.LoginEnabled,
    };
  }

  mapOwner(
    owner: AuthorityOwnerData,
    lookups: UserProfileLookups
  ): AuthorityOwnerModel {
    return {
      Id: owner.AuthorityOwnerId,
      PartnershipType: lookups?.PartnershipTypes?.find(
        (c) => c.id == owner.PartnershipType
      ),
      IdNumber: owner.IdNumber,
      Passport: owner.PassportNumber,
      Nationality: lookups?.Countries?.find((c) => c.id == owner.Nationality),
      NameAr: owner.NameAR,
      NameEn: owner.Name,
      Mobile: owner.Mobile,
    };
  }

  mapAgentToDto(agent: UserProfileAgentModel): AgentData {
    return {
      IndividualAgentID: agent.Id,
      IdNumber: agent.IdNumber,
      PassportNumber: agent.Passport,
      Name: agent.NameAr,
      Email: agent.Email,
      Mobile: agent.Mobile,
      PreferedLanguage: agent.PreferedLanguage?.nameEn,
      LoginEnabled: agent.LoginPermission,
    } as AgentData;
  }

  mapAgentDataToAgentDto(agent: UserProfileAgentModel): AgentDto {
    return {
      IdentityType: agent.IdentityType == 'IdNumber' ? 'ID' : 'Passport',
      IdentityNumber:
        agent.IdentityType == 'IdNumber' ? agent.IdNumber : agent.Passport,
      Name: agent.NameEn,
      Email: agent.Email,
      Phone: agent.Mobile,
      PreferedLanguage: agent.PreferedLanguage?.nameEn,
    } as AgentDto;
  }
}
